import { render, staticRenderFns } from "./ModalPurchaseOrders.vue?vue&type=template&id=48c80ad4&lang=pug&"
import script from "./ModalPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./ModalPurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./ModalPurchaseOrders.vue?vue&type=style&index=0&id=48c80ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports